export default {
  title: "Таърихи амалиётҳо",
  number: "Рақам",
  entityName: "Номи ташкилот",
  type: "Намуди амалиёт",
  typeBuyTariff: "Хариди тарофа",
  typeAddBalance: "Пур кардани баланс",
  typePaymentAct: "Пардохти ҳисоб тибқи акт",
  typePaymentAcceptance: "Пардохти санҷишӣ",
  amount: "Маблағ",
  currency: "Асъор",
  date: "Сана ва вақт",
  noHistory: "Таърихи шумо холӣ аст",
  operationsTab: "Ҳама амалиётҳо",
  processingTab: "RC Processing",
  reward: "Мукофот",
  paidFromPurchase:
    "{cash} {currency} пардохт шуд <span>(аз харид ба маблағи {amount} {currency})</span>",
  downloadModal: {
    title: "Боргирии файл",
    fileType: "Намуди файл",
    sendOnEmail: "Фиристодани нусха ба почта",
    CPUnloadingOperationHistory: "(КП) Боргирии таърихи амалиётҳо",
  },
  couldntCreateUnloading: "Сохтани боргирӣ муяссар нашуд",
  giftCard: "Корти тӯҳфа",
  orderNumber: "Рақами фармоиш",
  paymentMethod: "Тарзи пардохт",
  inCheckSpecifiedPercentAndSumAward:
    "Дар чек фоиз ва маблағи умумии мукофот нишон дода шудааст.",
  itsMayNotMatchWithFactSum:
    "Он метавонад бо маблағи воқеан ҳазфшудаи холҳо мувофиқат накунад, зеро вобаста ба он аст, ки кадом муштарӣ харид кардааст (дохилӣ ё хориҷӣ), инчунин аз тарофаи ӯ.",
};
